
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function SearchIcon(props) {
    const { style, onClick } = props;
    const classes = useStyles(props)()

    return(
        <svg onClick={onClick} className={classes.container}  style={style} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.007 11.981L19.702 16.675C20.538 17.511 20.538 18.864 19.702 19.7C18.867 20.537 17.512 20.537 16.677 19.7L11.982 15.008C10.814 15.669 9.463 16.048 8.024 16.048C3.593 16.049 0 12.457 0 8.025C0 3.593 3.593 0 8.025 0C12.458 0 16.05 3.593 16.05 8.025C16.05 9.463 15.67 10.814 15.007 11.981ZM8.025 13.91C11.275 13.91 13.91 11.273 13.91 8.025C13.91 4.775 11.275 2.14 8.025 2.14C4.775 2.14 2.141 4.775 2.141 8.025C2.141 11.273 4.774 13.91 8.025 13.91Z" fill="#192A7F"/>
        </svg>
    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));